/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import FutureSignupList from './FutureSignupList';

type FutureSignupsTabProps = {
  isSoul: boolean;
  prospectId: string;
};

const FutureSignupsTab = ({ isSoul, prospectId }: FutureSignupsTabProps) => (
  <div css={styles.tabPanel}>
    <FutureSignupList isSoul={isSoul} prospectId={prospectId} />
  </div>
);

export default FutureSignupsTab;

const styles = {
  tabPanel: css`
    margin: 0 -20px;
    overflow-y: auto;
  `,
};
